import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatSelectChange } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ToastsManager } from 'ng2-toastr';
import { BusinessRulesTypeEnum } from '../../../../enums/businessRulesTypes.enum';
import { BusinessRulesInterface } from '../../../../interfaces/business-rules.interface';
import { SalesChannelIface } from '../../../../interfaces/sales-channel.iface';
import { BusinessRulesService } from '../../../../services/business-rules.service';
import { SalesChannelService } from '../../../../services/sales-channel.service';
import { RemoveRuleDialogComponent } from '../../remove-rule-dialog/remove-rule-dialog.component';

@Component({
  selector: 'app-business-rules-max-price-drop',
  templateUrl: './business-rules-maxPriceDrop.component.html',
  styleUrls: ['./business-rules-maxPriceDrop.component.scss']
})
export class BusinessRulesMaxPriceDropComponent implements OnInit, OnChanges {
  @Output()
  businessRuleChange = new EventEmitter<BusinessRulesInterface[]>();
  @Output()
  isActivated = new EventEmitter<string>();

  @Input('businessRules')
  set rules(value: BusinessRulesInterface[]) {
    if (!value) {
      this._rules = [];
      return;
    }
    this._rules = value.filter(rule => rule.type === BusinessRulesTypeEnum.MAX_PRICE_DROP);
    this.businessRuleChange.emit(this._rules);
  }

  get rules(): BusinessRulesInterface[] {
    return this._rules;
  }

  private _rules: BusinessRulesInterface[];
  public priceDropForm: FormGroup;
  public selectedOption = 'new';
  public salesChannelList: string[];
  public segmentList: string[] = ['EOP', 'WINBACK'];
  public selectedRule: BusinessRulesInterface;
  public activeRule = [];
  public inActiveRule = [];
  isSubmitting = false;

  constructor(
    private toastr: ToastsManager,
    private businessRuleService: BusinessRulesService,
    private dialog: MatDialog,
    public translate: TranslateService,
    private salesChannelService: SalesChannelService
  ) {
    this.priceDropForm = new FormGroup({
      label: new FormControl('', [Validators.required]),
      priceDrop: new FormControl('', [Validators.required]),
      servicesCount: new FormControl('', [Validators.required]),
      salesChannel: new FormControl('', [Validators.required]),
      segment: new FormControl('', [Validators.required]),
      isActive: new FormControl(false)
    });
  }

  ngOnInit() {
    this.getSalesChannelsList();
  }

  ngOnChanges() {
    this.activeRule = this._rules.filter(rule => rule.isActive === true);
    this.inActiveRule = this._rules.filter(rule => rule.isActive === false);
  }

  getSalesChannelsList(): void {
    this.salesChannelService.getChannels().subscribe((channels: SalesChannelIface[]) => {
      this.salesChannelList = channels.map(channel => channel.name);
    });
  }

  onRuleChange(event: MatSelectChange): void {
    const rule = event.value;
    if (rule && rule !== 'new') {
      this.selectedRule = rule;
      this.priceDropForm.patchValue({
        ...rule.maxPriceDrop,
        isActive: rule.isActive
      });
    } else {
      this.selectedRule = null;
      this.priceDropForm.reset({
        isActive: false
      });
    }
  }

  saveRule(formData: FormGroup) {
    if (!this.selectedRule) {
      const { isActive, ...maxPriceDrop } = formData.getRawValue();
      const rule = {
        maxPriceDrop,
        isActive,
        type: BusinessRulesTypeEnum.MAX_PRICE_DROP
      };

      this.isSubmitting = true;

      this.businessRuleService.create(rule).subscribe(
        createdRule => {
          this.selectedRule = createdRule;
          this.rules.push(createdRule);
          this.isActivated.emit();
          this.isSubmitting = false;
          return this.toastr.success(this.translate.instant('BUSINESS_RULES_MAX_PRICE_DROP.COMPONENT.RULE_SAVED'));
        },
        () => {
          this.toastr.error(this.translate.instant('BUSINESS_RULES_MAX_PRICE_DROP.COMPONENT.RULE_SAVE_ERROR'));
          this.isSubmitting = false;
        }
      );
      return;
    }
    this.updateRule(formData);
  }

  updateRule(formData: FormGroup): void {
    const { isActive, ...maxPriceDrop } = formData.getRawValue();
    const businessRuleToBeUpdated = {
      maxPriceDrop,
      isActive,
      type: BusinessRulesTypeEnum.MAX_PRICE_DROP
    };

    this.isSubmitting = true;

    this.businessRuleService.update(businessRuleToBeUpdated, this.selectedRule._id).subscribe(
      businessRule => {
        this.selectedRule = businessRule;
        this.isActivated.emit();
        this.isSubmitting = false;
        return this.toastr.success(this.translate.instant('BUSINESS_RULES_MAX_PRICE_DROP.COMPONENT.RULE_UPDATED'));
      },
      () => {
        this.toastr.error(this.translate.instant('BUSINESS_RULES_MAX_PRICE_DROP.COMPONENT.RULE_UPDATE_ERROR'));
        this.isSubmitting = false;
      }
    );
  }

  deleteRuleModal() {
    this.dialog
      .open(RemoveRuleDialogComponent, { disableClose: true })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.deleteRule();
        }
      });
  }

  deleteRule(): void {
    this.isSubmitting = true;

    this.businessRuleService.delete(this.selectedRule._id).subscribe(
      () => {
        this._rules = this._rules.filter(rule => rule._id !== this.selectedRule._id);
        this.isActivated.emit();
        this.toastr.info(this.translate.instant('BUSINESS_RULES_MAX_PRICE_DROP.COMPONENT.RULE_DELETED'));
        this.priceDropForm.reset({
          isActive: false
        });
        this.selectedOption = 'new';
        this.selectedRule = null;
        this.isSubmitting = false;
      },
      () => {
        this.toastr.error(this.translate.instant('BUSINESS_RULES_MAX_PRICE_DROP.COMPONENT.RULE_DELETE_ERROR'));
        this.isSubmitting = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/business-rules/business-rules-components/business-rules-maxPriceDrop/business-rules-maxPriceDrop.component.ts